/** Generated by scripts/stampBuildInfo.cjs — do not edit manually. */
export const APP_BUILD_VERSION = "0.1.88";
export const APP_BUILD_ISO_TIME = "2026-11-01T12:30:45.524Z";
export const APP_PLAY_VERSION_CODE = 10;
export const APP_PLAY_VERSION_NAME = "1.0.10";
